import { useEffect, useImperativeHandle, useState } from 'react';
import { PilotAssignmentErrorCodes } from '../../services/DispatcherActions';
import Spacer from '../../../../components/layout/Spacer';
import {
    FieldWrapper,
} from "@progress/kendo-react-form";
import { Label } from '../../../../components/layout/Label';
import { DateTimePicker } from '../../../../components/layout/date-time/DateTimePicker';
import { toDateObject } from '../../../../components/helpers/DateTimeHelpers';
import { useHasEditableChanged } from '../hooks/usePilotAssignmentStore';

export const TimeDepartureReturnCard = (
    {
        ref,
        initializeIsDirty,
        assignmentService
    }) => {

    useImperativeHandle(ref, () => ({
        onPilotageChanged() {
            initialize();
        },
        onValidationChanged(codeStrings) {
            setHasDepartureTimeValidationError(codeStrings.includes(PilotAssignmentErrorCodes.PilotDepartureTimeIsMissing));
            setHasReturnTimeValidationError(codeStrings.includes(PilotAssignmentErrorCodes.PilotReturnTimeIsMissing));
        }
    }));

    const [departureTime, setDepartureTime] = useState(null);
    const [returnTime, setReturnTime] = useState(null);
    const [hasDepartureTimeValidationError, setHasDepartureTimeValidationError] = useState(false);
    const [hasReturnTimeValidationError, setHasReturnTimeValidationError] = useState(false);
    const [isEditable, setIsEditable] = useState(false);

    const hasEditableChanged = useHasEditableChanged();

    useEffect(() => {
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(!hasEditableChanged) return;
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasEditableChanged]);

    return (
        <>
            <Spacer height={10} />

            <FieldWrapper>
                <Label hasValidationError={hasDepartureTimeValidationError}>
                    Avreise:
                </Label>
                <div className="k-form-field-wrap">
                    <DateTimePicker
                        disabled={!isEditable}
                        hasValidationError={hasDepartureTimeValidationError}
                        title="Velg avreise tid"
                        value={departureTime}
                        onChange={onDepartureTimeChangeAsync} />
                </div>
            </FieldWrapper>

            <Spacer height={5} />

            <FieldWrapper>
                <Label hasValidationError={hasReturnTimeValidationError}>
                    Retur:
                </Label>
                <div className="k-form-field-wrap">
                    <DateTimePicker
                        disabled={!isEditable}
                        hasValidationError={hasReturnTimeValidationError}
                        title="Velg returtid"
                        value={returnTime}
                        onChange={onReturnTimeChangeAsync} />
                </div>
            </FieldWrapper>
        </>
    )

    function initialize() {
        const pilotAssignment = assignmentService.assignment;

        setDepartureTime(toDateObject(pilotAssignment.departureTime));
        setReturnTime(toDateObject(pilotAssignment.returnTime));
        setIsEditable(assignmentService.isEditable);
    }

    async function onDepartureTimeChangeAsync(e) {
        setDepartureTime(e);
        await assignmentService.onPilotDepartureTimeAsync(e);
        initializeIsDirty();
    }

    async function onReturnTimeChangeAsync(e) {
        setReturnTime(e);
        await assignmentService.onPilotReturnTimeAsync(e);
        initializeIsDirty();
    }
}
